import { useState } from 'react';
import type { SelecaoTabela } from '../../componentes/tabela';
import { LIMITE_EM_MASSA } from './crm-comum';

/** Seleção das listas do CRM (marcados de qualquer página), no formato da `Tabela`. */
export function useSelecaoCrm<T extends { id: string; nome: string }>(rotulo: (l: T) => string) {
  const [marcados, setMarcados] = useState<Set<string>>(new Set());
  const selecao: SelecaoTabela<T> = {
    marcados,
    rotulo,
    aoAlternar: (l, v) =>
      setMarcados((m) => {
        const n = new Set(m);
        if (v) n.add(l.id);
        else n.delete(l.id);
        return n;
      }),
    aoAlternarTodas: (linhas, v) =>
      setMarcados((m) => {
        const n = new Set(m);
        for (const l of linhas) {
          if (v) n.add(l.id);
          else n.delete(l.id);
        }
        return n;
      }),
  };
  return {
    selecao,
    ids: [...marcados],
    n: marcados.size,
    limpar: () => setMarcados(new Set()),
    /** RCRM5-ROB-M2: tira só estes da seleção (os feitos de uma ação em massa; os que falharam ficam marcados). */
    tirar: (ids: string[]) => setMarcados((m) => new Set([...m].filter((x) => !ids.includes(x)))),
    marcarTodos: (ids: string[]) => setMarcados(new Set(ids.slice(0, LIMITE_EM_MASSA))),
  };
}
